export enum Direction {
  UP,
  DOWN,
}
